// Menu panel texture (index.html "Menu panel texture"): circuit traces drawn once in 1 px cyan, mirrored to the four
// corners and set as --tx-art on #panel, whose ::before shows them behind the menu.
import { PALETTE } from './theme';

/** One corner of traces (top-left orientation): straight runs off the edges, a 45 degree bend, a square via. */
function circuitCorner(): HTMLCanvasElement {
  const W = 360, H = 220, cv = document.createElement('canvas'); cv.width = W; cv.height = H;
  const g = cv.getContext('2d')!; g.fillStyle = PALETTE.cyan;
  let seed = 7; const rnd = () => (seed = (seed * 16807) % 2147483647) / 2147483647; // fixed seed: the same art every time
  const pad = (x: number, y: number, s: number) => { g.fillRect(x - s, y - s, s * 2 + 1, s * 2 + 1); if (s > 1) g.clearRect(x - s + 1, y - s + 1, s * 2 - 1, s * 2 - 1); };
  for (let i = 0; i < 14; i++) {
    const fromTop = i % 2 === 0, off = 12 + Math.floor(rnd() * (fromTop ? W - 60 : H - 60)) & ~3;
    let x = fromTop ? off : 0, y = fromTop ? 0 : off;
    const run1 = 10 + Math.floor(rnd() * 30), run2 = 8 + Math.floor(rnd() * 40 * (1 - off / (fromTop ? W : H)));
    for (let k = 0; k < run1; k++) { g.fillRect(x, y, 1, 1); if (fromTop) y++; else x++; }
    for (let k = 0; k < run2; k++) { g.fillRect(x, y, 1, 1); x++; y++; }
    pad(x, y, 2);
  }
  pad(14, 14, 3); pad(26, 14, 1); pad(14, 26, 1);
  return cv;
}

function mirrored(src: HTMLCanvasElement, fx: boolean, fy: boolean): string {
  const cv = document.createElement('canvas'); cv.width = src.width; cv.height = src.height;
  const g = cv.getContext('2d')!; g.translate(fx ? cv.width : 0, fy ? cv.height : 0); g.scale(fx ? -1 : 1, fy ? -1 : 1); g.drawImage(src, 0, 0);
  return `url(${cv.toDataURL()})`;
}

export function paintMenuTexture() {
  const panel = document.getElementById('panel'); if (!panel) return;
  const c = circuitCorner();
  panel.style.setProperty('--tx-art', [mirrored(c, false, false), mirrored(c, true, false), mirrored(c, false, true), mirrored(c, true, true)].join(','));
}
